// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"a8aba8cb","745":"a8aba8cb"}[chunkId] + ".chunk.css";
};